import { IPersonDetailState } from "./state.store";
import { ActionTree } from "vuex";
import PersonStoreTypes from "./define-types.store";

const actions = <ActionTree<IPersonDetailState, any>>{
	[PersonStoreTypes.Get.PERSON_MODEL]: ({ getters, commit }, {id, tabs}) => {
		return new Promise((resolve, reject) => {
			getters.service.getPersonDetailById(id, tabs).then((response: any) => {
				commit(PersonStoreTypes.Set.PERSON_MODEL, response);
				return resolve(true);
			}).catch((error) => {
				return reject(error);
			});
		})
	},
};

export default actions;
